import { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { ContainerDiv } from './styles'


export default class SideWidget extends PureComponent {
  static propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
    header: PropTypes.string,
    headerIcon: PropTypes.string,
    className: PropTypes.string,
    starWidget: PropTypes.element,
  }

  static defaultProps = {
    header: undefined,
    headerIcon: undefined,
    className: undefined,
    starWidget: undefined,
  }

  render() {
    const {
      header,
      headerIcon,
      children,
      className,
      starWidget,
    } = this.props

    return (
      <ContainerDiv className={className}>
        <div className="innerDiv">
          <h2 className="header">
            {headerIcon} {header}
          </h2>
          <div className="entries">
            {children}
            {starWidget
              && <span className="innerWidget">{starWidget}</span>
            }
          </div>
        </div>
      </ContainerDiv>
    )
  }
}
